import React, { Component } from 'react';
import Style from './index.less';
import classNames from 'classnames';
import * as ICON from './preset-icons';
import ReflectionSpirit from './images/ReflectionSpirit';
import {
    EffectPropsField,
    DefaultEffectPresetProps,
} from '@src/framework/editor/src/js/constants';
import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import i18n from '@i18next/i18n';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IMAGE_PRESET_ICONS } from './preset-icons/index';
import { EMPTY_EFFECT } from '../preset-util/base-preset-util';
import Tooltip from '@tencent/dui/lib/components/Tooltip';
import { PresetElementType } from '@src/framework/workbench/const/preset-element-type';
import { SHAPE_PRESET_ICONS, TEXT_PRESET_ICONS } from './preset-icons';

const defaultReflectionProps = {
    ...DefaultEffectPresetProps[ActionType.REFLECTION],
    [EffectPropsField.STARTOPACITY.name]: 0,
    [EffectPropsField.SIZE.name]: 0,
};

const ReflectionPresetStyleList = [
    {
        style: 'close-0-dy', title: i18n.t('紧密映像： 接触'), key: 'close-0-dy',
    },
    {
        style: 'close-4-dy', title: i18n.t('紧密映像： 4磅 偏移量'), key: 'close-4-dy',
    },
    {
        style: 'close-8-dy', title: i18n.t('紧密映像： 8磅 偏移量'), key: 'close-8-dy',
    },
    {
        style: 'half-0-dy', title: i18n.t('半映像： 接触'), key: 'half-0-dy',
    },
    {
        style: 'half-4-dy', title: i18n.t('半映像： 4磅 偏移量'), key: 'half-4-dy',
    },
    {
        style: 'half-8-dy', title: i18n.t('半映像： 8磅 偏移量'), key: 'half-8-dy',
    },
    {
        style: 'full-0-dy', title: i18n.t('全映像： 接触'), key: 'full-0-dy',
    },
    {
        style: 'full-4-dy', title: i18n.t('全映像： 4磅 偏移量'), key: 'full-4-dy',
    },
    {
        style: 'full-8-dy', title: i18n.t('全映像： 8磅 偏移量'), key: 'full-8-dy',
    },
];

const ReflectionStyleAndPropsMapping = {
    'reflection-empty-click': null,
    'reflection-empty-hover': {
        ...defaultReflectionProps,
        [EffectPropsField.STARTOPACITY.name]: 0,
        [EffectPropsField.SIZE.name]: 0,
    },
    'close-0-dy': {
        ...defaultReflectionProps,
        [EffectPropsField.STARTOPACITY.name]: 48,
        [EffectPropsField.SIZE.name]: 35,
    },
    'close-4-dy': {
        ...defaultReflectionProps,
        [EffectPropsField.STARTOPACITY.name]: 50,
        [EffectPropsField.SIZE.name]: 39,
        [EffectPropsField.DISTANCE.name]: 4,
    },
    'close-8-dy': {
        ...defaultReflectionProps,
        [EffectPropsField.STARTOPACITY.name]: 50,
        [EffectPropsField.SIZE.name]: 40,
        [EffectPropsField.DISTANCE.name]: 8,
    },
    'half-0-dy': {
        ...defaultReflectionProps,
        [EffectPropsField.STARTOPACITY.name]: 50,
        [EffectPropsField.SIZE.name]: 55,
        [EffectPropsField.DISTANCE.name]: 0,
    },
    'half-4-dy': {
        ...defaultReflectionProps,
        [EffectPropsField.STARTOPACITY.name]: 50,
        [EffectPropsField.SIZE.name]: 56,
        [EffectPropsField.DISTANCE.name]: 4,
    },
    'half-8-dy': {
        ...defaultReflectionProps,
        [EffectPropsField.STARTOPACITY.name]: 50,
        [EffectPropsField.SIZE.name]: 56,
        [EffectPropsField.DISTANCE.name]: 8,
    },
    'full-0-dy': {
        ...defaultReflectionProps,
        [EffectPropsField.STARTOPACITY.name]: 50,
        [EffectPropsField.SIZE.name]: 90,
        [EffectPropsField.DISTANCE.name]: 0,
    },
    'full-4-dy': {
        ...defaultReflectionProps,
        [EffectPropsField.STARTOPACITY.name]: 50,
        [EffectPropsField.SIZE.name]: 90,
        [EffectPropsField.DISTANCE.name]: 4,
    },
    'full-8-dy': {
        ...defaultReflectionProps,
        [EffectPropsField.STARTOPACITY.name]: 50,
        [EffectPropsField.SIZE.name]: 92,
        [EffectPropsField.DISTANCE.name]: 8,
    },
} as const;

type ReflectionStyle = typeof ReflectionStyleAndPropsMapping[keyof typeof ReflectionStyleAndPropsMapping];

interface ReflectionPresetMenuProps {
    preset: { style: string };
    onReflectionPresetStyleClick: (props: ReflectionStyle) => void;
    onReflectionPresetStyleMouseEnter: (props: ReflectionStyle) => void;
    onReflectionPresetStyleMouseLeave: () => void;
    presetElementType?: PresetElementType;
}

export default class ReflectionPresetMenu extends Component<ReflectionPresetMenuProps> {
    public render() {
        const icons = this.getPresetIcons();
        const presetList = ReflectionPresetStyleList;
        return (
            <div className={classNames(Style.container, 'reflection-preset')}>
                <div className={Style['reflection-type-title']}>{i18n.t('无映像')}</div>
                <div className={Style['reflection-collection']}>
                    <div className={classNames({
                        [Style['reflection-collection-item']]: true,
                        [Style['reflection-item-selected']]: EMPTY_EFFECT === this.props.preset.style,
                    })}
                    onClick={() => this.handleReflectionPresetIconClick('reflection-empty-click')}
                    onMouseEnter={() => this.handleReflectionPresetIconMouseEnter('reflection-empty-hover')}
                    onMouseLeave={() => this.handleReflectionPresetIconMouseLeave()}
                    >
                        <Tooltip placement={['top', 'right']} title={i18n.t('无')}>
                            <div className={Style['reflection-item-img']}>
                                <img src={icons[EMPTY_EFFECT]}/>
                            </div>
                        </Tooltip>
                    </div>
                </div>
                <div className={Style['reflection-type-title']}>{i18n.t('映像')}</div>
                <div className={Style['reflection-collection']}>
                    {presetList.map(item => this.renderReflectionPresetIcon(item))}
                </div>
            </div>
        );
    }

    private getPresetIcons = () => {
        if (this.props.presetElementType === PresetElementType.IMAGE) {
            return IMAGE_PRESET_ICONS;
        }
        if (this.props.presetElementType === PresetElementType.TEXT) {
            return TEXT_PRESET_ICONS;
        }
        return SHAPE_PRESET_ICONS;
    };

    private renderReflectionPresetIcon(item: { key: string; style: string, title: string }) {
        const isSelected = item.style === this.props.preset.style;
        const reflectionItemClass = classNames({
            [Style['reflection-collection-item']]: true,
            [Style['reflection-item-selected']]: isSelected,
        });
        const icons = this.getPresetIcons();

        return (
            <div
                key={item.key}
                className={reflectionItemClass}
                onMouseEnter={() => this.handleReflectionPresetIconMouseEnter(item.style)}
                onClick={() => this.handleReflectionPresetIconClick(item.style)}
                onMouseLeave={() => this.handleReflectionPresetIconMouseLeave()}
            >
                <Tooltip placement={['top', 'right']} title={i18n.t(item.title)}>
                    <div className={Style['preset-icon']}>
                        <img src={icons[item.style]}/>
                    </div>
                </Tooltip>
            </div>
        );
    }

    private handleReflectionPresetIconMouseEnter = (style: string) => {
        const value = ReflectionStyleAndPropsMapping[style];
        this.props.onReflectionPresetStyleMouseEnter(value ? { ...value } : value);
    };

    private handleReflectionPresetIconClick = (style: string) => {
        const value = ReflectionStyleAndPropsMapping[style];
        this.props.onReflectionPresetStyleClick(value ? { ...value } : value);
    };

    private handleReflectionPresetIconMouseLeave = () => {
        this.props.onReflectionPresetStyleMouseLeave();
    };
}
